module.exports = __webpack_public_path__ + "static/media/03.b81a1209.jpg";